import { useEffect } from "react"

const useScripts = (scripts) => {
  useEffect(() => {
    const appendedScripts = scripts
      ? scripts.map((scriptUrl) => {
          const script = document.createElement("script")
          script.src = scriptUrl
          script.type = "text/javascript"
          script.defer = true
          document.head.prepend(script)
          return script
        })
      : []
    return () => appendedScripts.forEach((script) => document.head.removeChild(script))
  }, [scripts])
}

export default useScripts
